import { ApiNotification } from './shared'

export const mapNotification = ({
  notification_id: id,
  source_type: sourceType,
  type,
  message: mustacheTemplate,
  properties,
  read,
  timestamp,
  messageVariables
}: ApiNotification) => ({
  id,
  sourceType,
  type,
  mustacheTemplate,
  properties: !!properties ? properties : [],
  read,
  timestamp,
  messageVariables
})
